import { type ApiStatusType, getApiResponseMapping } from "./responseHandling";
import { actionExecution } from "./appHandling";
import type { actions, ActionType } from "../constants/appActions";

export interface MFAHandler<T> extends ApiStatusType {}

export const parseMFA = <T>(action: any): MFAHandler<T> | undefined => {
  // Check if the response indicates MFA is required
  const responseCode = action?.payload?.code;

  // Handle MFA Required case (200 OK with MFARequired code)
  if (responseCode === "MFARequired") {
    const mfaMapping = getApiResponseMapping(200, "MFARequired");
    return {
      status: 200, // Use actual status from response
      code: mfaMapping.code,
      action: mfaMapping.action as (typeof actions)[keyof typeof actions],
      actionType:
        mfaMapping.actionType as (typeof ActionType)[keyof typeof ActionType],
      message: action?.payload?.message || mfaMapping.message,
      detail: action?.payload?.detail || mfaMapping.detail,
      showDetails: mfaMapping.showDetails,
    };
  }

  // Return undefined if no MFA requirement detected
  return undefined;
};
